module.exports = __webpack_public_path__ + "img/card-services-month-certification.e58e649a.svg";